import { gsap, TimelineLite, Power4 } from 'gsap';

let _root;
let tl;
let _overlayLayer;
let _closeOverlayBtn;
let _overlaySearch;
let _buttonSearch;

export default class SearchOverlay {
    constructor(root) {
        _root = this;

        _overlayLayer = document.querySelector('#overlay-layer');
        _closeOverlayBtn = document.querySelector('#close-overlay');
        _overlaySearch = document.querySelector('#overlay-search-container');
        _buttonSearch = document.querySelector('#button-search');

        this.initButton();
    }

    initButton() {
        if ('undefined' != typeof _buttonSearch && null != _buttonSearch) {
            _root.addEvent(_buttonSearch, 'click', _root.onClickSearchBtn);
        }
    }

    onClickSearchBtn(el) {
        el.preventDefault();

        tl = new TimelineLite({ onComplete: _root.onCompleteTimelineLite, onReverseComplete: _root.reverseFunction });
        tl.set(_overlayLayer, { display: 'block', width: 0 });
        tl.set(_overlaySearch, { display: 'block', autoAlpha: 0 });
        tl.to(_overlayLayer, 0.5, { width: '100%', ease: Power4.easeInOut });
        tl.to(_overlaySearch, 0.5, { autoAlpha: 1 });
        tl.set(_closeOverlayBtn, { display: 'block', autoAlpha: 0 });
        tl.to(_closeOverlayBtn, 0.5, { autoAlpha: 1 });

        _root.removeEvent(_buttonSearch, 'click', _root.onClickSearchBtn);
    }

    onCompleteTimelineLite() {
        _root.addEvent(_closeOverlayBtn, 'click', _root.onClickCloseEvent);
    }

    onClickMenuItem(el) {
        tl.reverse();
    }

    reverseFunction() {
        _root.initButton();
    }

    onClickCloseEvent(el) {
        el.preventDefault();
        tl.reverse();
    }

    addEvent(el, type, handler) {
        if (el.attachEvent) el.attachEvent('on' + type, handler);
        else el.addEventListener(type, handler);
    }

    removeEvent(el, type, handler) {
        if (el.detachEvent) el.detachEvent('on' + type, handler);
        else el.removeEventListener(type, handler);
    }
}